export default __webpack_public_path__ + "static/media/Inter-school Competition flyer.843e7c47.pdf";